import { Hero } from "../components/Hero";
import { Features } from "../components/Features";
import { HowItWorks } from "../components/HowItWorks";
import { Community } from "../components/Community";
import { CTA } from "../components/CTA";
import { AlertCircle } from "lucide-react";

interface HomeProps {
  onNavigate?: (page: string) => void;
}

export function Home({ onNavigate }: HomeProps = {}) {
  return (
    <>
      <Hero onNavigate={onNavigate} />
      
      {/* Important Disclaimer Banner */}
      <div className="bg-gradient-to-r from-accent/40 via-accent/30 to-accent/40 border-y border-primary/20 py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-center gap-4 bg-card/50 backdrop-blur-sm rounded-2xl p-6 border border-border shadow-lg">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <AlertCircle className="w-6 h-6 text-primary" />
              </div>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <p className="text-base sm:text-lg">
                <span className="font-medium text-foreground">Important: </span>
                <span className="text-foreground">CannaBias does not sell cannabis or provide medical advice.</span>
              </p>
              <p className="text-sm text-muted-foreground mt-1">
                We are an independent review platform for UK prescribed medical cannabis patients.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <HowItWorks />
      <Features />
      <Community />
      <CTA />
    </>
  );
}